import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { from, of } from 'rxjs';
import { catchError, finalize, last, map, mergeMap, switchMap, tap } from 'rxjs/operators';
import { SnackBarItem } from 'src/app/shared/global_components/snack-bar/snack-bar-item';
import { BaseClass } from 'src/app/shared/models/base-class';
import { LayoutService } from 'src/app/shared/services/common/layout.service';
import { StorageManagerService } from 'src/app/shared/services/common/storage-manager.service';
import { AuthService } from 'src/app/shared/services/rest/auth.service';
import { CompanyService } from 'src/app/shared/services/rest/company.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-duplicate-group',
  templateUrl: './duplicate-group.component.html',
  styleUrls: ['./duplicate-group.component.scss']
})
export class DuplicateGroupComponent extends BaseClass implements OnInit, OnDestroy {
  public host: any = environment.host;
  public imgRoute: any = '';
  public user: any = {};
  public user_id: number;
  public form: FormGroup;
  public company_id: any;
  public page: number = 1;
  public isSubmit: boolean = false;
  public isFormChange: boolean = false;
  public platforms: any;
  public contentTypes: any;
  public channelsToGroup: any;
  public platformsData = []

  
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<DuplicateGroupComponent>,
    private layoutService: LayoutService,
    private sm: StorageManagerService,
    private auth: AuthService,
    private companyService: CompanyService,
    private fb: FormBuilder,
  ) { super() }

  ngOnInit(): void {
    console.log("DuplicateGroupComponent", this.data)
    this.getCompany();
    this.getImgRoute();
    this.getCsrf();
    this.getUser();
    this.getPlatforms();
    this.getContentTypes();
    this.getChannelsToGroup();



    this.form = this.fb.group({
      name: [this.data.group.name, Validators.required],
      description: this.data.group.description,
    })

    this.attachSubscriptions(
      this.form.valueChanges.subscribe(() => this.isFormChange = true)
    )

    this.attachSubscriptions(
      this.dialogRef.backdropClick().subscribe(e => {
        e.preventDefault();
        if (this.isFormChange) {
          this.layoutService.openBottomSheet(this.dialogRef);
        } else {
          this.close();
        }
      })
    )
  }

  getContentTypes() {
    this.attachSubscriptions(
      this.companyService.getContentTypes(null, '1').pipe(
        map(el => el.body)
      ).subscribe(resp => {
        this.contentTypes = resp;
        console.log("getContentTypes", this.contentTypes)
      })
    )
  }

  getTypesByPlatform(id) {
    if (!this.contentTypes || this.contentTypes.filter(el => el.platform_id == id).length == 0) {
      return false;
    }
    return this.contentTypes.filter(el => el.platform_id == id)
  }

  getPlatformById(id) {
    if (!this.platforms || this.platforms.filter(el => el.id == id).length == 0) {
      return false;
    }
    return this.platforms.find(el => el.id == id)
  }

  getPlatforms() {
    this.attachSubscriptions(
      this.companyService.getGroupPlatforms().subscribe(resp => {
        this.platforms = resp;
      })
    )
  }

  getChannelsToGroup() {
    this.attachSubscriptions(
      this.companyService.getChannelsToGroup(this.data.company.id, {group_id: this.data.group.id}).pipe(
        map(el => el.body)
      ).subscribe(resp => {
        console.log("getChannelsToGroup channelsToGroup", resp)
        this.channelsToGroup = resp
        resp.forEach(chToGroup => {
          if (chToGroup.channel && !this.platformsData.filter(k => k.platform_id == chToGroup.channel.platform_id).length) {
            this.platformsData.push({
              platform_id: chToGroup.channel.platform_id,
              content_type_id: 0
            })
          }
        });
      })
    )
  }

  getCompany() {
    this.attachSubscriptions(
      this.companyService.getCompany(this.data.company_id).subscribe(resp => {
        this.companyService.company$.next(resp[0]);
      })
    )
  }

  getImgRoute() {
    this.attachSubscriptions(
      this.sm.getImgPath().subscribe(el => {
        this.imgRoute = el;
      })
    )
  }

  getCsrf() {
    this.attachSubscriptions(
      this.auth.$userToken.subscribe(resp => {
        this.user_id = resp.user_id;
        this.sm.localStorageSetItem("csrf_param", resp.csrf_param)
        this.sm.localStorageSetItem("csrf_token", resp.csrf_token)
      })
    )
  }

  getUser() {
    this.attachSubscriptions(
      this.auth.$user.subscribe(resp => {
        this.user = resp;
      })
    )
  }

  onSubmit() {
    this.isSubmit = true;
    this.form.value.company_id = this.data.company_id;
    this.attachSubscriptions(
      this.companyService.createGroupCompany(this.form.value).pipe(
        switchMap(newGroup => {
          return from(this.channelsToGroup).pipe(
            mergeMap((chToGroup:any) => {
              let sbmtData = {
                company_id: chToGroup.company_id,
                channel_id: chToGroup.channel_id,
                content_type_id: chToGroup.channel && !!this.platformsData.find(p => p.platform_id == chToGroup.channel.platform_id) && !!this.platformsData.find(p => p.platform_id == chToGroup.channel.platform_id).content_type_id ? this.platformsData.find(p => p.platform_id == chToGroup.channel.platform_id).content_type_id : chToGroup.content_type_id,
                channel_group_id: newGroup.id
              }
              return this.companyService.addChannelToGroup(sbmtData, this.data.company.id)
              .pipe(
                catchError(() => of([])),
              )
            }, 10), // 10 запросов параллельно
            finalize(() => {
              console.log('Все pingImports запросы завершены');
              // Здесь можно дополнительно обработать card.is_ok_tags или другие поля
            }),
            last()
          )
        })
      ).subscribe(resp => {
        this.isSubmit = false;
        this.dialogRef.close({event: "update", data: resp});
      }, error => {
        this.isSubmit = false;
        this.layoutService.showSnackBar({name: ''}, error, SnackBarItem)
      })
    )
  }

  close() {
    this.dialogRef.close({event: "close", data: false})
  }

  ngOnDestroy(): void {
    this.clearSubscriptions();
  }
}
